import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 33 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20.497 2.666h-1.333c-3.771 0-5.657 0-6.828 1.172s-1.172 3.057-1.172 6.828v10.667c0 3.77 0 5.657 1.172 6.828s3.057 1.172 6.828 1.172h1.333c3.772 0 5.657 0 6.829-1.172s1.171-3.057 1.171-6.828V10.666c0-3.771 0-5.657-1.171-6.828s-3.057-1.172-6.829-1.172",
      opacity: ".6"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.167 10.667c0-2.05 0-3.543.188-4.667h-.188c-3.143 0-4.714 0-5.69.976-.977.977-.977 2.548-.977 5.69v6.667c0 3.143 0 4.714.976 5.69.977.977 2.548.977 5.69.977h.189c-.188-1.124-.188-2.617-.188-4.667V10.667",
      opacity: ".4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M19.871 15.294a1 1 0 0 1 0 1.414l-2.666 2.666a1 1 0 0 1-1.415-1.414l.96-.96H7.164a1 1 0 0 1 0-2h9.586l-.96-.959a1 1 0 0 1 1.415-1.414z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }